// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Arango Downloads Plugin Styles */

.arango-downloads {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  max-width: 100%;
  margin: 0 auto;
}

/* Loading Spinner */
.arango-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
}

.arango-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007cba;
  border-radius: 50%;
  animation: arango-spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes arango-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Error Message */
.arango-error {
  text-align: center;
  padding: 2rem;
  background: #fff2f2;
  border: 1px solid #ff6b6b;
  border-radius: 8px;
  margin: 1rem 0;
}

.arango-error-icon {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.arango-error h3 {
  color: #d63031;
  margin: 0 0 0.5rem 0;
}

.arango-error p {
  color: #666;
  margin: 0 0 1rem 0;
}

.arango-retry-btn {
  background: #007cba;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}

.arango-retry-btn:hover {
  background: #005a87;
}

/* Empty State */
.arango-downloads-empty {
  text-align: center;
  padding: 2rem;
  color: #666;
  background: #f8f9fa;
  border-radius: 8px;
  margin: 1rem 0;
}

/* Download List */
.arango-downloads-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* Download Item */
.arango-download-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
  background: white;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s, transform 0.2s;
}

.arango-download-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.arango-download-header {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  flex: 1;
}

.arango-download-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
  margin-top: 0.25rem;
}

.arango-download-info {
  flex: 1;
  min-width: 0;
}

.arango-download-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 0.5rem 0;
  line-height: 1.3;
}

.arango-download-description {
  color: #666;
  font-size: 0.9rem;
  margin: 0 0 0.75rem 0;
  line-height: 1.4;
}

.arango-download-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  font-size: 0.8rem;
  color: #666;
}

.arango-download-category {
  background: #e3f2fd;
  color: #1976d2;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-weight: 500;
}

.arango-download-size {
  color: #666;
}

.arango-download-date {
  color: #999;
}

.arango-download-count {
  color: #28a745;
  font-weight: 500;
}

/* Download Button */
.arango-download-actions {
  flex-shrink: 0;
  margin-left: 1rem;
}

.arango-download-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #007cba;
  color: white;
  border: none;
  padding: 0.75rem 1.25rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
  text-decoration: none;
  min-width: 120px;
  justify-content: center;
}

.arango-download-btn:hover:not(:disabled) {
  background: #005a87;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 124, 186, 0.3);
}

.arango-download-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.arango-download-btn.downloading {
  background: #28a745;
}

.arango-download-btn-text {
  flex: 1;
}

.arango-download-btn-icon {
  font-size: 0.8rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .arango-download-item {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }
  
  .arango-download-header {
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .arango-download-actions {
    margin-left: 0;
    align-self: stretch;
  }
  
  .arango-download-btn {
    width: 100%;
    justify-content: center;
  }
  
  .arango-download-meta {
    flex-direction: column;
    gap: 0.5rem;
  }
}

@media (max-width: 480px) {
  .arango-download-item {
    padding: 1rem;
  }
  
  .arango-download-title {
    font-size: 1rem;
  }
  
  .arango-download-description {
    font-size: 0.85rem;
  }
  
  .arango-download-meta {
    font-size: 0.75rem;
  }
}

/* WordPress Theme Compatibility */
.wp-block {
  margin: 0;
}

/* Download Table */
.download-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  table-layout: fixed;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.download-table th,
.download-table td {
  padding: 1rem;
  text-align: left;
  vertical-align: top;
  border-bottom: 1px solid #e2e8f0;
  border-right: none;
  border-left: none;
}

.download-table th {
  background: #044926;
  color: white;
  font-weight: 600;
  font-size: 0.875rem;
  border-bottom: 2px solid #044926;
}

.download-table tr:hover {
  background-color: rgba(185, 255, 56, 0.05);
}

.download-table tr:last-child td {
  border-bottom: none;
}

.download-table th:nth-child(1),
.download-table td:nth-child(1) {
  width: 12%; /* Type column */
}

.download-table th:nth-child(2),
.download-table td:nth-child(2) {
  width: 8%; /* Architecture column */
}

.download-table th:nth-child(3),
.download-table td:nth-child(3) {
  width: 50%; /* File column - more space for file names and SHA256 */
}

.download-table th:nth-child(4),
.download-table td:nth-child(4) {
  width: 8%; /* Size column */
}

.download-table th:nth-child(5),
.download-table td:nth-child(5) {
  width: 15%; /* Download column */
}

.download-table th {
  background: #f8fafc;
  font-weight: 600;
  color: #1e293b;
}

.download-table td {
  color: #64748b;
}

.download-link {
  color: #3b82f6;
  text-decoration: none;
  font-weight: 500;
}

.download-link:hover {
  text-decoration: underline;
}

.checksum {
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.75rem;
  color: #64748b;
  word-break: break-all;
  overflow-wrap: break-word;
}

/* Responsive Table Styles */
@media (max-width: 768px) {
  .download-table {
    font-size: 0.875rem;
  }
  
  .download-table th,
  .download-table td {
    padding: 0.5rem 0.25rem;
  }
  
  .download-table th:nth-child(1),
  .download-table td:nth-child(1) {
    width: 15%; /* Type column */
  }
  
  .download-table th:nth-child(2),
  .download-table td:nth-child(2) {
    width: 10%; /* Architecture column */
  }
  
  .download-table th:nth-child(3),
  .download-table td:nth-child(3) {
    width: 45%; /* File column */
  }
  
  .download-table th:nth-child(4),
  .download-table td:nth-child(4) {
    width: 8%; /* Size column */
  }
  
  .download-table th:nth-child(5),
  .download-table td:nth-child(5) {
    width: 17%; /* Download column */
  }
  
  .checksum {
    font-size: 0.7rem;
  }
  .download-table {
    font-size: 0.75rem;
    display: block;
    width: 100%;
    border: none;
  }
  
  .download-table thead {
    display: none;
  }
  
  .download-table tbody {
    display: block;
    width: 100%;
  }
  
  .download-table tr {
    display: block;
    border: 1px solid #e2e8f0;
    border-radius: 0.5rem;
    margin-bottom: 1rem;
    padding: 1rem;
    background: white;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
    width: 100%;
  }
  
  .download-table td {
    display: block;
    padding: 0.5rem 0;
    border: none !important;
    text-align: left;
    width: 100%;
  }
  
  .download-table td > div {
    width: 100%;
  }
  
  .download-table td .font-mono {
    word-break: break-all;
    overflow-wrap: break-word;
  }
  
  .download-table td:before {
    content: attr(data-label) ": ";
    font-weight: 600;
    color: #374151;
    display: block;
    margin-bottom: 0.25rem;
  }
  
  .download-table td:nth-child(1):before {
    content: "Type: ";
  }
  
  .download-table td:nth-child(2):before {
    content: "Arch: ";
  }
  
  .download-table td:nth-child(3):before {
    content: "File: ";
  }
  
  .download-table td:nth-child(4):before {
    content: "Size: ";
  }
  
  .download-table td:nth-child(5):before {
    content: "Download: ";
  }
  
  .checksum {
    font-size: 0.65rem;
  }
}

/* Tab Navigation Responsive */
@media (max-width: 768px) {
  .tab-navigation {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  
  .tab-button {
    flex: 1;
    min-width: 120px;
    font-size: 0.875rem;
    padding: 0.75rem 0.5rem;
  }
  
  .tab-button img {
    width: 1rem;
    height: 1rem;
  }
}

@media (max-width: 480px) {
  .tab-navigation {
    flex-direction: column;
    gap: 0.25rem;
  }
  
  .tab-button {
    width: 100%;
    min-width: auto;
    font-size: 0.8rem;
    padding: 0.625rem 0.5rem;
  }
  
  .tab-button img {
    width: 0.875rem;
    height: 0.875rem;
  }
}

/* Distribution Grid Responsive */
@media (max-width: 768px) {
  .distribution-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
  }
  
  .distribution-button {
    padding: 0.75rem 0.5rem;
    font-size: 0.875rem;
  }
  
  .distribution-button img {
    width: 1.25rem;
    height: 1.25rem;
  }
}

@media (max-width: 480px) {
  .distribution-grid {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
  
  .distribution-button {
    padding: 0.625rem 0.5rem;
    font-size: 0.8rem;
  }
  
  .distribution-button img {
    width: 1rem;
    height: 1rem;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .arango-download-item {
    background: #2c3e50;
    border-color: #34495e;
    color: #ecf0f1;
  }
  
  .arango-download-title {
    color: #ecf0f1;
  }
  
  .arango-download-description {
    color: #bdc3c7;
  }
  
  .arango-download-meta {
    color: #bdc3c7;
  }
  
  .arango-downloads-empty {
    background: #34495e;
    color: #bdc3c7;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,yGAAyG;EACzG,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,kCAAkC;AAClC;EACE,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,UAAU,EAAE,gBAAgB;AAC9B;;AAEA;;EAEE,SAAS,EAAE,wBAAwB;AACrC;;AAEA;;EAEE,UAAU,EAAE,uDAAuD;AACrE;;AAEA;;EAEE,SAAS,EAAE,gBAAgB;AAC7B;;AAEA;;EAEE,UAAU,EAAE,oBAAoB;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wDAAwD;EACxD,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE;IACE,mBAAmB;EACrB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;;IAEE,UAAU,EAAE,gBAAgB;EAC9B;;EAEA;;IAEE,UAAU,EAAE,wBAAwB;EACtC;;EAEA;;IAEE,UAAU,EAAE,gBAAgB;EAC9B;;EAEA;;IAEE,SAAS,EAAE,gBAAgB;EAC7B;;EAEA;;IAEE,UAAU,EAAE,oBAAoB;EAClC;;EAEA;IACE,iBAAiB;EACnB;EAIA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,0CAA0C;IAC1C,WAAW;EACb;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;AA7EF;;AAgFA,8BAA8B;AAC9B;EACE;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,OAAO;IACP,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;AACF","sourcesContent":["/* Arango Downloads Plugin Styles */\n\n.arango-downloads {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n/* Loading Spinner */\n.arango-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  text-align: center;\n}\n\n.arango-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #007cba;\n  border-radius: 50%;\n  animation: arango-spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes arango-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Error Message */\n.arango-error {\n  text-align: center;\n  padding: 2rem;\n  background: #fff2f2;\n  border: 1px solid #ff6b6b;\n  border-radius: 8px;\n  margin: 1rem 0;\n}\n\n.arango-error-icon {\n  font-size: 2rem;\n  margin-bottom: 1rem;\n}\n\n.arango-error h3 {\n  color: #d63031;\n  margin: 0 0 0.5rem 0;\n}\n\n.arango-error p {\n  color: #666;\n  margin: 0 0 1rem 0;\n}\n\n.arango-retry-btn {\n  background: #007cba;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.2s;\n}\n\n.arango-retry-btn:hover {\n  background: #005a87;\n}\n\n/* Empty State */\n.arango-downloads-empty {\n  text-align: center;\n  padding: 2rem;\n  color: #666;\n  background: #f8f9fa;\n  border-radius: 8px;\n  margin: 1rem 0;\n}\n\n/* Download List */\n.arango-downloads-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n/* Download Item */\n.arango-download-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.5rem;\n  background: white;\n  border: 1px solid #e1e5e9;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  transition: box-shadow 0.2s, transform 0.2s;\n}\n\n.arango-download-item:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transform: translateY(-1px);\n}\n\n.arango-download-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  flex: 1;\n}\n\n.arango-download-icon {\n  font-size: 1.5rem;\n  flex-shrink: 0;\n  margin-top: 0.25rem;\n}\n\n.arango-download-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.arango-download-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #2c3e50;\n  margin: 0 0 0.5rem 0;\n  line-height: 1.3;\n}\n\n.arango-download-description {\n  color: #666;\n  font-size: 0.9rem;\n  margin: 0 0 0.75rem 0;\n  line-height: 1.4;\n}\n\n.arango-download-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  font-size: 0.8rem;\n  color: #666;\n}\n\n.arango-download-category {\n  background: #e3f2fd;\n  color: #1976d2;\n  padding: 0.25rem 0.5rem;\n  border-radius: 12px;\n  font-weight: 500;\n}\n\n.arango-download-size {\n  color: #666;\n}\n\n.arango-download-date {\n  color: #999;\n}\n\n.arango-download-count {\n  color: #28a745;\n  font-weight: 500;\n}\n\n/* Download Button */\n.arango-download-actions {\n  flex-shrink: 0;\n  margin-left: 1rem;\n}\n\n.arango-download-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: #007cba;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.25rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: all 0.2s;\n  text-decoration: none;\n  min-width: 120px;\n  justify-content: center;\n}\n\n.arango-download-btn:hover:not(:disabled) {\n  background: #005a87;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 124, 186, 0.3);\n}\n\n.arango-download-btn:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.arango-download-btn.downloading {\n  background: #28a745;\n}\n\n.arango-download-btn-text {\n  flex: 1;\n}\n\n.arango-download-btn-icon {\n  font-size: 0.8rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .arango-download-item {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 1rem;\n  }\n  \n  .arango-download-header {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n  \n  .arango-download-actions {\n    margin-left: 0;\n    align-self: stretch;\n  }\n  \n  .arango-download-btn {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .arango-download-meta {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .arango-download-item {\n    padding: 1rem;\n  }\n  \n  .arango-download-title {\n    font-size: 1rem;\n  }\n  \n  .arango-download-description {\n    font-size: 0.85rem;\n  }\n  \n  .arango-download-meta {\n    font-size: 0.75rem;\n  }\n}\n\n/* WordPress Theme Compatibility */\n.wp-block {\n  margin: 0;\n}\n\n/* Download Table */\n.download-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1rem;\n  table-layout: fixed;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);\n}\n\n.download-table th,\n.download-table td {\n  padding: 1rem;\n  text-align: left;\n  vertical-align: top;\n  border-bottom: 1px solid #e2e8f0;\n  border-right: none;\n  border-left: none;\n}\n\n.download-table th {\n  background: #044926;\n  color: white;\n  font-weight: 600;\n  font-size: 0.875rem;\n  border-bottom: 2px solid #044926;\n}\n\n.download-table tr:hover {\n  background-color: rgba(185, 255, 56, 0.05);\n}\n\n.download-table tr:last-child td {\n  border-bottom: none;\n}\n\n.download-table th:nth-child(1),\n.download-table td:nth-child(1) {\n  width: 12%; /* Type column */\n}\n\n.download-table th:nth-child(2),\n.download-table td:nth-child(2) {\n  width: 8%; /* Architecture column */\n}\n\n.download-table th:nth-child(3),\n.download-table td:nth-child(3) {\n  width: 50%; /* File column - more space for file names and SHA256 */\n}\n\n.download-table th:nth-child(4),\n.download-table td:nth-child(4) {\n  width: 8%; /* Size column */\n}\n\n.download-table th:nth-child(5),\n.download-table td:nth-child(5) {\n  width: 15%; /* Download column */\n}\n\n.download-table th {\n  background: #f8fafc;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.download-table td {\n  color: #64748b;\n}\n\n.download-link {\n  color: #3b82f6;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.download-link:hover {\n  text-decoration: underline;\n}\n\n.checksum {\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  font-size: 0.75rem;\n  color: #64748b;\n  word-break: break-all;\n  overflow-wrap: break-word;\n}\n\n/* Responsive Table Styles */\n@media (max-width: 768px) {\n  .download-table {\n    font-size: 0.875rem;\n  }\n  \n  .download-table th,\n  .download-table td {\n    padding: 0.5rem 0.25rem;\n  }\n  \n  .download-table th:nth-child(1),\n  .download-table td:nth-child(1) {\n    width: 15%; /* Type column */\n  }\n  \n  .download-table th:nth-child(2),\n  .download-table td:nth-child(2) {\n    width: 10%; /* Architecture column */\n  }\n  \n  .download-table th:nth-child(3),\n  .download-table td:nth-child(3) {\n    width: 45%; /* File column */\n  }\n  \n  .download-table th:nth-child(4),\n  .download-table td:nth-child(4) {\n    width: 8%; /* Size column */\n  }\n  \n  .download-table th:nth-child(5),\n  .download-table td:nth-child(5) {\n    width: 17%; /* Download column */\n  }\n  \n  .checksum {\n    font-size: 0.7rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .download-table {\n    font-size: 0.75rem;\n    display: block;\n    width: 100%;\n    border: none;\n  }\n  \n  .download-table thead {\n    display: none;\n  }\n  \n  .download-table tbody {\n    display: block;\n    width: 100%;\n  }\n  \n  .download-table tr {\n    display: block;\n    border: 1px solid #e2e8f0;\n    border-radius: 0.5rem;\n    margin-bottom: 1rem;\n    padding: 1rem;\n    background: white;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);\n    width: 100%;\n  }\n  \n  .download-table td {\n    display: block;\n    padding: 0.5rem 0;\n    border: none !important;\n    text-align: left;\n    width: 100%;\n  }\n  \n  .download-table td > div {\n    width: 100%;\n  }\n  \n  .download-table td .font-mono {\n    word-break: break-all;\n    overflow-wrap: break-word;\n  }\n  \n  .download-table td:before {\n    content: attr(data-label) \": \";\n    font-weight: 600;\n    color: #374151;\n    display: block;\n    margin-bottom: 0.25rem;\n  }\n  \n  .download-table td:nth-child(1):before {\n    content: \"Type: \";\n  }\n  \n  .download-table td:nth-child(2):before {\n    content: \"Arch: \";\n  }\n  \n  .download-table td:nth-child(3):before {\n    content: \"File: \";\n  }\n  \n  .download-table td:nth-child(4):before {\n    content: \"Size: \";\n  }\n  \n  .download-table td:nth-child(5):before {\n    content: \"Download: \";\n  }\n  \n  .checksum {\n    font-size: 0.65rem;\n  }\n}\n\n/* Tab Navigation Responsive */\n@media (max-width: 768px) {\n  .tab-navigation {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n  \n  .tab-button {\n    flex: 1;\n    min-width: 120px;\n    font-size: 0.875rem;\n    padding: 0.75rem 0.5rem;\n  }\n  \n  .tab-button img {\n    width: 1rem;\n    height: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .tab-navigation {\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n  \n  .tab-button {\n    width: 100%;\n    min-width: auto;\n    font-size: 0.8rem;\n    padding: 0.625rem 0.5rem;\n  }\n  \n  .tab-button img {\n    width: 0.875rem;\n    height: 0.875rem;\n  }\n}\n\n/* Distribution Grid Responsive */\n@media (max-width: 768px) {\n  .distribution-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.75rem;\n  }\n  \n  .distribution-button {\n    padding: 0.75rem 0.5rem;\n    font-size: 0.875rem;\n  }\n  \n  .distribution-button img {\n    width: 1.25rem;\n    height: 1.25rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .distribution-grid {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n  }\n  \n  .distribution-button {\n    padding: 0.625rem 0.5rem;\n    font-size: 0.8rem;\n  }\n  \n  .distribution-button img {\n    width: 1rem;\n    height: 1rem;\n  }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n  .arango-download-item {\n    background: #2c3e50;\n    border-color: #34495e;\n    color: #ecf0f1;\n  }\n  \n  .arango-download-title {\n    color: #ecf0f1;\n  }\n  \n  .arango-download-description {\n    color: #bdc3c7;\n  }\n  \n  .arango-download-meta {\n    color: #bdc3c7;\n  }\n  \n  .arango-downloads-empty {\n    background: #34495e;\n    color: #bdc3c7;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
